export default __webpack_public_path__ + "static/subscribe-d6958eb4570db3fed19374b6979ce4ab.png";